export default __webpack_public_path__ + "static/media/vector.42edcd5a.svg";